var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("Header", [
        _c("div", { staticClass: "layout-img" }, [
          _c("img", { attrs: { src: require("@/assets/login_logo.png") } })
        ]),
        _c(
          "div",
          { staticClass: "breadcrumb-container" },
          [
            _c(
              "Breadcrumb",
              { attrs: { separator: _vm.path !== "" ? ">" : "" } },
              [
                _vm.changeRoute && _vm.path.name
                  ? _c(
                      "BreadcrumbItem",
                      [
                        _vm.path.meta && _vm.path.meta.icon
                          ? _c("svg-icon", {
                              attrs: { "icon-class": _vm.path.meta.icon }
                            })
                          : _vm._e(),
                        _vm._v(" " + _vm._s(_vm.path.name) + " ")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.$route.meta && _vm.$route.meta.parent
                  ? _c(
                      "BreadcrumbItem",
                      { attrs: { to: _vm.toGroup } },
                      [
                        _vm.path.meta && _vm.path.meta.icon && !_vm.path.name
                          ? _c("svg-icon", {
                              attrs: { "icon-class": _vm.path.meta.icon }
                            })
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.parent.name) + " ")
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.$route.meta.parent
                  ? _c(
                      "BreadcrumbItem",
                      { attrs: { to: _vm.$route } },
                      [
                        _vm.path.meta && _vm.path.meta.icon && !_vm.path.name
                          ? _c("svg-icon", {
                              attrs: { "icon-class": _vm.path.meta.icon }
                            })
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.$route.name) + " ")
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "layout-user" },
          [
            _c("download-list", { staticClass: "menu-items" }),
            _c(
              "div",
              { staticClass: "notice-icon" },
              [
                _c(
                  "Poptip",
                  {
                    attrs: { placement: "bottom", width: "355" },
                    on: {
                      "on-popper-show": function($event) {
                        return _vm.getNoticeItemList()
                      }
                    }
                  },
                  [
                    _c(
                      "Badge",
                      { attrs: { dot: _vm.showDot } },
                      [
                        _c("Icon", {
                          attrs: {
                            type: "ios-notifications-outline",
                            size: "26"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("notice-list", {
                          attrs: { "notice-list": _vm.noticeList },
                          on: {
                            "check-notice": _vm.checkNotice,
                            "delete-notice": _vm.deleteNotice,
                            "change-dot": _vm.changeDot
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "Poptip",
              [
                _c("Avatar", { attrs: { icon: "ios-person" } }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$store.getters.userInfo &&
                        _vm.$store.getters.userInfo.description
                        ? _vm.$store.getters.userInfo.description
                        : _vm.$store.getters.userInfo.unm
                    )
                  )
                ]),
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c(
                    "a",
                    { on: { click: _vm.logout } },
                    [
                      _c("svg-icon", { attrs: { "icon-class": "log-out" } }),
                      _c("span", [_vm._v("退出登陆")])
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "Layout",
        { staticClass: "layout-menu" },
        [
          _c(
            "Sider",
            {
              attrs: {
                breakpoint: "md",
                collapsible: "",
                "collapsed-width": 68
              },
              model: {
                value: _vm.isCollapsed,
                callback: function($$v) {
                  _vm.isCollapsed = $$v
                },
                expression: "isCollapsed"
              }
            },
            [
              _c(
                "Menu",
                {
                  ref: "menuList",
                  class: _vm.menuitemClasses,
                  attrs: {
                    "active-name": _vm.$route.meta.parent
                      ? _vm.path.path + "/" + _vm.parent.path
                      : _vm.$route.path,
                    "open-names": _vm.openNames,
                    theme: "dark",
                    width: "auto",
                    accordion: ""
                  },
                  on: {
                    "on-select": _vm.choseItem,
                    "on-open-change": _vm.openSubmenu
                  }
                },
                [
                  _vm._l(_vm.constantRouterMap, function(item) {
                    return [
                      (!_vm.hasOneShowingChildren(item.children) ||
                        item.parentHidden) &&
                      _vm.hasMenuPermission(item) &&
                      !item.hidden &&
                      !_vm.isCollapsed
                        ? _c(
                            "MenuItem",
                            {
                              key: item.name,
                              class: _vm.menuitemClasses,
                              attrs: {
                                to: item.path,
                                "active-name": _vm.$route.path,
                                name: item.path
                              }
                            },
                            [
                              item.meta && item.meta.icon
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": item.meta.icon }
                                  })
                                : _vm._e(),
                              _c("span", [_vm._v(_vm._s(_vm.getTitle(item)))])
                            ],
                            1
                          )
                        : !_vm.isCollapsed
                        ? _c("side-menu", {
                            key: item.path,
                            attrs: {
                              "menu-item": item,
                              "active-name": _vm.$route.path,
                              "has-permission": _vm.hasMenuPermission
                            }
                          })
                        : !item.hidden
                        ? _c(
                            "Dropdown",
                            {
                              key: item.path,
                              staticStyle: { "margin-left": "2px" },
                              attrs: {
                                trigger: "click",
                                placement: "right-start"
                              }
                            },
                            [
                              _vm.hasOneShowingChildren(item.children) &&
                              _vm.hasMenuPermission(item)
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown",
                                      attrs: { href: "javascript:void(0)" }
                                    },
                                    [
                                      item.meta && item.meta.icon
                                        ? _c("svg-icon", {
                                            attrs: {
                                              "icon-class": item.meta.icon
                                            }
                                          })
                                        : _vm._e(),
                                      _c("span", [_vm._v(_vm._s(item.name))])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._l(item.children, function(children, index) {
                                return _c(
                                  "DropdownMenu",
                                  {
                                    key: index,
                                    attrs: { slot: "list" },
                                    slot: "list"
                                  },
                                  [
                                    _vm.hasMenuPermission(children) &&
                                    !children.hidden
                                      ? _c(
                                          "DropdownItem",
                                          {
                                            staticClass: "menu-dropdown",
                                            staticStyle: {
                                              margin: "0",
                                              color: "#fff"
                                            }
                                          },
                                          [
                                            _c(
                                              "MenuItem",
                                              {
                                                attrs: {
                                                  name: children.path,
                                                  to: children,
                                                  "active-name": _vm.$route.path
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.getTitle(children))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Layout",
        [
          _c(
            "Content",
            {
              class: _vm.isCollapsed ? "collapsed-page-container" : "",
              style: { padding: "16px" }
            },
            [
              _c(
                "div",
                {
                  ref: "pageContainer",
                  staticClass: "page-container",
                  class: { noSider: _vm.noSider },
                  on: {
                    click: function($event) {
                      return _vm.$store.dispatch("app/closeSideBar")
                    }
                  }
                },
                [
                  _c(
                    "transition",
                    { attrs: { mode: "out-in", name: "page" } },
                    [
                      _c(
                        "keep-alive",
                        [_c("router-view", { key: _vm.$route.fullPath })],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }